module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "shopify-section",
    attrs: {
      "id": "shopify-section-footer"
    }
  }, [_c('footer', {
    staticClass: "site-footer",
    attrs: {
      "role": "contentinfo"
    }
  }, [_c('div', {
    staticClass: "page-width"
  }, [_c('div', {
    staticClass: "grid footer-top"
  }, [_c('aside', {
    staticClass: "col-sm-6 col-md-3 col-lg-4",
    attrs: {
      "id": "nav_menu-1532932009490"
    }
  }, [_vm._m(0), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/aboutUs"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("About Us")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/privacyPolicy"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Privacy Policy")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/exchangeAndCancellations"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Exchange & Cancellations")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contactUs"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact Us")])])], 1)]), _c('hr', {
    staticClass: "medium-up--hide"
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _c('hr'), _vm._m(3)])])]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "h4",
    staticStyle: {
      "margin": "0% 6%"
    }
  }, [_vm._v("Informations"), _c('i', {
    staticClass: "ad ad-angle-down-l medium-up--hide"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "col-sm-6 col-md-3 col-lg-4",
    attrs: {
      "id": "text-1540197818915"
    }
  }, [_c('h4', {
    staticClass: "h4",
    staticStyle: {
      "margin": "0% 6%"
    }
  }, [_vm._v("Contact Us")]), _c('ul', {
    staticClass: "addressFooter"
  }, [_c('li', [_c('p', {
    staticStyle: {
      "margin": "0% -8%"
    }
  }, [_vm._v("Kathmandu, Nepal")])]), _vm._v(" "), _c('li', {
    staticClass: "phone"
  }, [_c('i', {
    staticClass: "ad ad-phone-l"
  }), _c('p', {
    staticStyle: {
      "margin": "0% -8%"
    }
  }, [_c('a', {
    attrs: {
      "href": "tel:+91-9911437000"
    }
  }, [_vm._v("+91-9911437000")])])]), _c('li', {
    staticClass: "email"
  }, [_c('i', {
    staticClass: "ad ad-envelope-l"
  }), _c('p', {
    staticStyle: {
      "margin": "0% -8%"
    }
  }, [_c('a', {
    attrs: {
      "href": "mailto:Talk.lilpicks@gmail.com"
    }
  }, [_vm._v("Talk.lilpicks@gmail.com")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "col-sm-6 col-md-3 col-lg-4",
    attrs: {
      "id": "text-1600966736723"
    }
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("Become a part of our family!")]), _vm._v(" "), _c('p', [_vm._v("Get Parenting insights, advice, crazy stories, crazier offers + discounts! No spam, pinky promise!")]), _vm._v(" "), _c('form', {
    staticClass: "contact-form",
    attrs: {
      "method": "post",
      "action": "/contact#contact_form",
      "id": "contact_form",
      "accept-charset": "UTF-8"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "form_type",
      "value": "customer"
    }
  }), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "utf8",
      "value": "✓"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "contact[tags]",
      "value": "newsletter"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-group__field newsletter__input",
    attrs: {
      "type": "email",
      "name": "contact[email]",
      "id": "Email",
      "value": "",
      "placeholder": "Email address",
      "autocorrect": "off",
      "autocapitalize": "off"
    }
  }), _c('span', {
    staticClass: "input-group__btn"
  }, [_c('button', {
    staticClass: "btn newsletter__submit",
    attrs: {
      "type": "submit",
      "name": "commit",
      "id": "Subscribe"
    }
  }, [_c('span', {
    staticClass: "newsletter__submit-text--large"
  }, [_vm._v("Subscribe")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bottom grid"
  }, [_c('div', {
    staticClass: "grid--table"
  }, [_c('div', {
    staticClass: "grid__item small--text-center medium-up--one-whole text-center"
  }, [_c('span', [_vm._v("© 2020 LILPICKS.")]), _vm._v(" All Rights Reserved. \n                      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-modal shadow",
    attrs: {
      "data-popup-modal": "one"
    }
  }, [_c('div', {
    staticClass: "popup-modal__close"
  }, [_vm._v("\nX\n ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f50f8b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ecommerce/footerWebsite.vue
// module id = 2121
// module chunks = 0